import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, concatMap, firstValueFrom, from, map, Subject, take, takeUntil, timer, zip } from 'rxjs';
import { FireService } from 'src/app/services/fire.service';
import { NodeService } from 'src/app/services/node.service';
import { GlobalService } from 'src/app/shared/global.service';
import Utf8 from "crypto-js/enc-utf8";


@Component({
  selector: 'app-new-compilation',
  templateUrl: './new-compilation.component.html',
  styleUrls: ['./new-compilation.component.scss']
})
export class NewCompilationComponent implements OnInit, OnDestroy {
  registrationForm!: FormGroup;
  public sessoList: string[] = [];
  public currentStep = 0;
  public progress = 0;
  public urlDecoded = '';
  questionnaire: string;
  version: string;
  client: string;
  repart: string;
  loading: boolean = false;
  license: any;
  tecnico: any = '';
  showForm: boolean = false;
  flagSelected: string;
  resultsPrivacy: any = [];
  checkbox: any;
  checkboxes: any;
  isRadioSelected: any = [];
  optionSelected: any = [];
  isValidPrivacyCheckboxes: boolean = false;
  idForceManager: any;
  isForceManagerCompilation: boolean;
  private destroy$ = new Subject<void>();

  constructor(public fb: FormBuilder, public node: NodeService, public translate: TranslateService, private route: ActivatedRoute, private g: GlobalService, private fire: FireService, private router: Router) {

    this.flagSelected = '';
    this.g.selectedLanguage = 'it';
    this.translate.use(/*browserLang === 'it' ? 'it' :*/     this.g.selectedLanguage);
    

     /*
    let client = 'A88';

    const mappings = [
      ['R2U25','R3U1'],
    ];

    from(mappings).pipe(
      concatMap(([sourceL, targetL]) => {
        const [repartS, clientS] = sourceL.split('U');
        const [repartT, clientT] = targetL.split('U');

        this.g.copyDocumentFromSourceToTarget(client, repartS, `U${clientS}`, repartT, `U${clientT}`, true);
        this.g.copyDocumentFromSourceToTarget(client, 'L1', sourceL, 'L2', targetL, false);

        return timer(1000); // Wait 1 second before the next iteration
      })
    ).subscribe();
    */


    // Initialize the registration form with validation rules
    this.registrationForm = this.fb.group({
      step1: this.fb.group({
        name: ['', [Validators.required, Validators.minLength(2)]],
        surname: ['', [Validators.required, Validators.minLength(2)]],
      }),
      step2: this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        emailConfirm: ['', [Validators.required, Validators.email]],
      }),
      step3: this.fb.group({
        birthday: ['', [Validators.required, this.ageValidator(18)]],
        gender: ['', Validators.required],
      }),
      // Initialize step4 with privacyCheckboxes FormArray and validation
      step4: this.fb.group({
        privacyCheckboxes: this.fb.array([]), // Custom validator
      }),
    });

    this.updateProgress();

    // Fetch gender options for the selection
    this.translate.get('sessoList').pipe(take(1)).subscribe({
      next: (res: string[]) => { this.sessoList = res; },
      error: (err) => console.debug('[NewCompilation] sessoList error', err),
    });

    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      try {
        this.idForceManager = params.idForceManager ? params.idForceManager : '';
        this.isForceManagerCompilation = this.idForceManager !== '';
        const decodedUrl = this.g.decryptData(params.url);

        if (decodedUrl === null || decodedUrl === undefined || decodedUrl === '') {
          throw ('Invalid URL');
        }
        const [questionnaire, version, client, license, repart] = decodedUrl.split('/');
        Object.assign(this, { questionnaire, version, client, license, repart });

      }
      catch (e) {
        console.warn(e);
        this.router.navigateByUrl('/compilazione/accesso-vietato');
      }
    });


  }



  ageValidator(minAge: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // If no value, return null (handled by required validator)

      const birthDate = new Date(control.value);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();

      const isOldEnough =
        age > minAge || (age === minAge && today >= new Date(birthDate.setFullYear(today.getFullYear())));

      return isOldEnough ? null : { ageInvalid: true };
    };
  }


  async ngOnInit() {
    this.selectFlag('it');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  async selectFlag(flag: string) {
    this.translate.use(flag);
    this.showForm = true;
    this.flagSelected = '';
    this.translate.use(flag === 'it' ? 'it' : 'en');
    this.translate.get('sessoList').pipe(take(1)).subscribe({
      next: (res: string[]) => { this.sessoList = res; },
      error: (err) => console.debug('[NewCompilation] sessoList error', err),
    });

    try {
      // One-shot server-first: valueChanges+firstValueFrom emetteva la cache
      // IndexedDB stale (contatore `utilizzate` non aggiornato).
      const licenzeSnap: any = await firstValueFrom(
        this.fire.getDocOnce("clienti", this.client, "licenze", this.license)
      );
      const licenzeSnapshot: any = licenzeSnap?.exists
        ? { ...licenzeSnap.data(), id: licenzeSnap.id }
        : undefined;

      this.tecnico = licenzeSnapshot?.tecnico ?? '';

      if (licenzeSnapshot?.utilizzate >= licenzeSnapshot?.totali) {
        this.router.navigateByUrl("/compilazione/accesso-vietato");
      }
    } catch (error) {
      console.debug("[NewCompilation] licenza error:", error);
    }
  }


  async downloadFile(path: string) {
    await this.g.downloadPrivacy(path, window.location.hostname);
  }



  stepForm(step: string): FormGroup {
    return this.registrationForm.get(step) as FormGroup;
  }

  async loadPrivacy() {
    try {
      this.resultsPrivacy = [];

      const snapshot = await firstValueFrom(
        this.fire.db.collection<any>('privacy', ref =>
          ref.where('licenze', 'array-contains', this.questionnaire)
        )
          .snapshotChanges()
          .pipe(
            map(snapshot =>
              snapshot
                .map(doc => doc.payload.doc.data() as any)
                .filter(docData => docData?.attivo)
            ),
            catchError(error => {
              console.debug("Errore durante il recupero dei documenti: ", error);
              return [[]]; // Restituisce un array vuoto in caso di errore
            })
          )
      );

      if (this.idForceManager === '' && this.flagSelected !== '') {
        this.resultsPrivacy = snapshot.filter(elem => elem.titolo.toLowerCase().includes(this.flagSelected) && elem.isAllegatoPrivacy) || [];
      }
      else {
        this.resultsPrivacy = snapshot.filter(elem => elem.titolo.toLowerCase().includes('anagrafica'))

      }

      if (this.resultsPrivacy && this.resultsPrivacy.length > 0) {
        this.buildPrivacyCheckboxes(this.resultsPrivacy[0].checkbox.ITA);
      }

    } catch (error) {
      console.debug(" Errore privacy:", error);
    }
  }




  buildPrivacyCheckboxes(privacyData: any[]) {
    const step4 = this.registrationForm.get('step4.privacyCheckboxes') as FormArray;

    step4.clear(); // Clear existing FormArray controls

    privacyData.forEach(item => {
      const privacyGroup = this.fb.group({
        id: [item.id || null],
        codice: [item.codice],
        testo: [item.testo],
        accetto: [item.accetto, item.richiesto ? Validators.required : []],
        non_accetto: [item.non_accetto],
        richiesto: [item.richiesto],
      });

      step4.push(privacyGroup);
    });
  }


  areAllGroupsValid(): boolean {
    const privacyCheckboxes = this.registrationForm.get('step4.privacyCheckboxes') as FormArray;
    return this.isForceManagerCompilation ? privacyCheckboxes.controls.every(group => group.valid) && this.isRadioSelected.length === privacyCheckboxes.controls.length : this.isRadioSelected.length === privacyCheckboxes.length;

  }


  getPrivacyControl(index: number, value: string) {
    let control = (this.registrationForm.get('step4.privacyCheckboxes') as FormArray).at(index);

    if (control) {
      const controlValue = control.value;
      if (controlValue.richiesto && controlValue.accetto !== value) {
        control.setErrors({ invalid: true });
      } else {
        control.setErrors(null);
      }
      return control.status !== 'VALID';
    }

    return false;
  }


  getPrivacyCheckboxesControls(): FormGroup[] {
    return (this.stepForm('step4').get('privacyCheckboxes') as FormArray)?.controls as FormGroup[];
  }



  async nextStep() {
    if (this.stepForm(`step${this.currentStep + 1}`).valid) {
      this.currentStep++;
      this.updateProgress();
    }
    if (this.currentStep === 2) {
      await this.loadPrivacy();
    }
  }

  prevStep(): void {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.updateProgress();
    }
  }

  updateProgress(): void {
    this.progress = ((this.currentStep) / 3) * 100;
  }


  onSubmitEmail() {
    const emailControl = this.stepForm('step2').get('email');
    const emailConfirmControl = this.stepForm('step2').get('emailConfirm');

    emailControl?.markAsTouched();
    emailConfirmControl?.markAsTouched();
    if (this.stepForm('step2').valid) {
      this.nextStep();
    }
  }


  async onSubmit() {
    if (!this.registrationForm.valid || !this.areAllGroupsValid()) {
      this.translate.get(['policyInvalid', 'policyRequired']).pipe(take(1)).subscribe({
        next: translations => {
          this.g.createErrorNotification(translations['policyInvalid'], translations['policyRequired']);
        },
        error: (err) => console.debug('[NewCompilation] translate error', err),
      });

      return
    };

    this.loading = true;
    try {
      const inputForm = {
        ...this.registrationForm.value.step1,
        ...this.registrationForm.value.step2,
        ...this.registrationForm.value.step3
      };

      // Recupero utenti esistenti
      // One-shot server-first (no cache stale): il calcolo di nextUtente deve
      // vedere gli utenti appena creati da altre compilazioni.
      const utentiSnap: any = await firstValueFrom(
        this.fire.getSubCollectionOnce('clienti', this.client, 'reparti', this.repart, 'utenti')
      );
      const utenti: any[] = (utentiSnap?.docs ?? []).map((d: any) => ({ ...d.data(), id: d.id }));

      // Calcolo del codice utente successivo
      let nextUtente = utenti.length
        ? Math.max(...utenti.map((el: any) => Number(el.codice) || 0)) + 1
        : 1;

      // Controllo se l'utente esiste già
      const existingUser = utenti.find(
        (el: any) => el.email.trim().toLowerCase() === inputForm.email.trim().toLowerCase()
      );

      const nominativo = `${inputForm.name.toUpperCase().trim()} ${inputForm.surname.toUpperCase().trim()}`;
      if (!existingUser) {
        // Creazione di un nuovo utente
        const newUser = {
          admin: false,
          attivo: true,
          codice: nextUtente,
          descrizione: nominativo,
          email: inputForm.email.trim().toLowerCase(),
          id: `U${nextUtente}`,
          idForcemanager: this.idForceManager,
          mobile: "",
          reparto: this.repart,
          sendtype: false,
          ...this.registrationForm.value.step1,
          ...this.registrationForm.value.step2,
          ...this.registrationForm.value.step3,
          ...this.isRadioSelected.map((value, index) => ({
            [`P${index + 1}`]: value
          })).reduce((acc, curr) => ({ ...acc, ...curr }), {})

        };

        await this.fire.addSingleSubDoc(
          'clienti', 'reparti', 'utenti', this.client, this.repart, newUser
        );
      } else {
        nextUtente = Number(existingUser.codice) || 1;
      }

      // Verifica se la compilazione esiste
      const compilazioneSnap: any = await firstValueFrom(
        this.fire.getSubDocOnce(
          'clienti', this.client, 'licenze', this.license, 'compilazioni', `${this.repart}U${nextUtente}`
        )
      );
      const compilazioneExists: any = compilazioneSnap?.exists
        ? { ...compilazioneSnap.data(), id: compilazioneSnap.id }
        : undefined;

      if (!compilazioneExists || Object.keys(compilazioneExists).length < 2) {
        await this.fire.incrementUtilizzate({ clienti: this.client, licenze: this.license });

        await this.fire.addSubCollection(
          "clienti", "licenze", "compilazioni",
          { sent: true, utente: `U${nextUtente}`, reparto: this.repart, dataInvio: new Date() },
          this.client, this.license, `${this.repart}U${nextUtente}`
        );
      }

      // Creazione del link personalizzato
      const customLink = {
        azienda: this.client,
        licenza: this.license,
        reparto: this.repart,
        nominativo: nominativo,
        idForceManager: this.idForceManager,
        email: inputForm.email.trim().toLowerCase(),
        utente: `U${nextUtente}`,
        tecnico: this.tecnico,
        language: this.isForceManagerCompilation ? 'it' : this.flagSelected,
        messaggio: ' ',
      };

      // Cifratura e invio email
      const encryptLink = this.g.encryptData(
        Utf8.parse(JSON.stringify(customLink))
      );

      if (true) {
        const urlNextPage = "/compilazione/" + encryptLink;
        this.router.navigateByUrl(urlNextPage);

      }
      else {
        this.g.sendMail(
          { user: inputForm.email.trim().toLowerCase(), link: encryptLink },
          false, this.flagSelected
        );

        // Passaggio al passo successivo
        this.currentStep++;
        this.updateProgress();
      }

    } catch (error) {
      console.debug("Errore durante la registrazione:", error);
    }

    this.loading = false;
  }

  // Call this function when a radio button is clicked
  onRadioSelect(index: number, option: string) {
    this.isRadioSelected[index] = true ;
    this.optionSelected[index] = option;
 // Set to true when at least one option is selected
    // Set true for the selected option's index
  }

  openOption(index: number) {
    this.isRadioSelected[index] = false;
  }


  sanitizeInput(controlName: string): void {
    const control = this.registrationForm.get(controlName);
    if (control) {
      const sanitizedValue = control.value?.replace(/<[^>]*>/g, ''); // Remove any HTML tags

      // Only update if the value has changed to avoid infinite loop
      if (sanitizedValue !== control.value) {
        control.setValue(sanitizedValue, { emitEvent: false }); // Prevent triggering ngModelChange again
      }
    }
  }

}
